export const PREDICTION_COLOR="#E2A9F3"
export const REALDATA_COLOR="#4682B4"
export const BRUSHING_COLOR="#ff8010"
export const NO_PREDICTION_COLOR="#E2A9F3"
export const PARALLELCOORDINATES_PREDCITION_SEEDATA_COLOR="#eb3d72"

export const PARALLELCOORDINATES_PREDCITION_INCORRECT_SEEDATA_COLOR="#edece9"